import * as React from 'react';

/**
 * @return {React.ReactElement}
 * @constructor
 */
export default function DocumentType(): React.ReactElement {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#document_type)">
        <path d="M24.4289 9.00051C23.7188 9.00051 23.1431 8.42487 23.1431 7.71477V0.000488281H7.71456C5.58432 0.000488281 3.85742 1.72739 3.85742 3.85763V32.1433C3.85742 34.2736 5.58432 36.0005 7.71456 36.0005H28.286C30.4162 36.0005 32.1431 34.2736 32.1431 32.1433V9.00051H24.4289Z" fill="currentColor"/>
        <path d="M25.7148 0.753174V6.42829H31.39L25.7148 0.753174Z" fill="currentColor"/>
      </g>
      <defs>
        <clipPath id="document_type">
          <rect width="36" height="36" fill="white" transform="translate(0 0.000488281)"/>
        </clipPath>
      </defs>
    </svg>
  );
}
